<p-dialog 
  [(visible)]="visible" 
  [header]="config.header"
  class="confirmation-dialog"
  [modal]="true"
  [style]="{ width: config.width }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()">
  
  <div class="confirmation-content">
    <div class="confirmation-body">
      <h3 class="body-header m-0">{{ config.bodyHeader }}</h3>
      <p class="body-subtitle">{{ config.bodySubtitle }}</p>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="button-container">
      <button 
        pButton 
        [label]="config.noButtonText ?? 'no'"
        [class]="'p-button-text no-button btn ' + config.noBtnCss"
        [style.color]="config.noButtonColor"
        (click)="handleCancel()">
      </button>
      <button 
        pButton 
        [label]="config.yesButtonText ?? 'yes'"
        [class]="'yes-button btn ' + config.yesBtnCss"
        [style.background-color]="config.yesButtonColor"
        [style.border-color]="config.yesButtonColor"
        (click)="handleConfirm()">
      </button>
    </div>
  </ng-template>
</p-dialog>